import { render } from "./LupaSandiPage.vue?vue&type=template&id=6551dfba&scoped=true"
import script from "./LupaSandiPage.vue?vue&type=script&lang=js"
export * from "./LupaSandiPage.vue?vue&type=script&lang=js"

import "./LupaSandiPage.vue?vue&type=style&index=0&id=6551dfba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6551dfba"]])

export default __exports__